import React, { useContext } from 'react';
import { EditableFieldsContext } from '../../../context';
import { Node } from '@contentful/rich-text-types';

import { Btn } from 'components/btn/Btn';
import { useContentfulGlobalContent } from 'common/api/contentful/global';
import { renderContent } from 'features/homepage/sections/components/HeroSectionTextBlock';
import Skeleton from 'react-loading-skeleton';
import { BaseAddBankAccountFlow } from './BaseAddBankAccountFlow';

export const AddBankAccountPromptSection = ({ id }: { id: string }) => {
    const { setFieldToEdit } = useContext(EditableFieldsContext);
    const globalContent = useContentfulGlobalContent();
    const linkABankAccount = () => {
        // turn on editMode here to show case the address selection
        setFieldToEdit(id);
    };

    if (!globalContent) {
        return <Skeleton height={100} />;
    }

    return (
        <BaseAddBankAccountFlow id={id}>
            <div className="text-grey-1">
                {renderContent(globalContent?.noAchLinkedPrompt as Node)}
                <Btn className="payment_options_add_bank_button" onClick={linkABankAccount}>
                    Link a Bank Account
                </Btn>
            </div>
        </BaseAddBankAccountFlow>
    );
};
